var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertAnnotationExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0631 11.0312C15.0631 10.3355 14.5309 9.77148 13.8743 9.77148C13.2178 9.77148 12.6855 10.3355 12.6855 11.0312V13.0467C12.6855 13.7425 13.2178 14.3064 13.8743 14.3064C14.5309 14.3064 15.0631 13.7425 15.0631 13.0467V11.0312ZM13.8743 18.3375C14.5309 18.3375 15.0631 17.7734 15.0631 17.0778C15.0631 16.382 14.5309 15.8181 13.8743 15.8181C13.2178 15.8181 12.6855 16.382 12.6855 17.0778C12.6855 17.7734 13.2178 18.3375 13.8743 18.3375Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.375 8.75H19.25V7H8.75V8.75H9.625V10.8624L12.7626 14L9.625 17.1376V19.25H8.75V21H19.25V19.25H18.375V17.1376L15.2374 14L18.375 10.8624V8.75ZM11.375 10.1376V8.75H16.625V10.1376L14 12.7626L11.375 10.1376Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertAnnotationExpired);
export default __webpack_public_path__ + "static/media/AlertAnnotationExpired.fb5a6f32905f124817386c7e2cc358ef.svg";
export { ForwardRef as ReactComponent };